import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { compose } from "recompose";

import { Api } from "@api/index";
import { ApiButton } from "@api/components/ApiButton";
import { connectToApi, ApiConnectedOwnProps } from "@api/components/connectToApi";
import { AuthState } from "@auth/models";
import { FilesState } from "@files/models";
import { MusicState } from "@music/models";
import { Alert } from "@ui/Alert";
import { REPORT_TYPE_CUSTOM_IDS } from "../../constants";
import { messages } from "../../messages";
import { Report, ReportsState } from "../../models";
import {
    getCustomReportsList,
    getLastLoadedCustomReports,
    getNextCustomReportsPage,
    getRequestIdCustomReports,
    hasMoreCustomReportsPages,
} from "../../selectors";
import { CustomReportsTable } from "../CustomReportsTable";

type State = ReportsState & FilesState & MusicState & AuthState;

interface CustomReportsListStateProps extends ApiConnectedOwnProps {
    reports: Report[];
    morePages: boolean;
    nextPage: number;
}

type Props = CustomReportsListStateProps;

const CustomReportsList = ({ reports, morePages, nextPage }: Props) => {
    const loadMore = () => Api.reportsIndex(nextPage, { typeIds: REPORT_TYPE_CUSTOM_IDS });

    return (
        <div className="custom-reports-list">
            <Alert style="info">
                <FormattedMessage {...messages.customReportsInfo} />
            </Alert>
            <CustomReportsTable reports={reports} />
            {morePages &&
                <div className="custom-reports-list__load-more">
                    <ApiButton actionCreators={[loadMore]}>
                        <FormattedMessage {...messages.loadMoreReports} />
                    </ApiButton>
                </div>
            }
        </div>
    );
};

const mapStateToProps = (state: State): CustomReportsListStateProps => ({
    reports: getCustomReportsList(state),
    morePages: hasMoreCustomReportsPages(state),
    nextPage: getNextCustomReportsPage(state),
    requestId: [getRequestIdCustomReports(state)], // force reload when there's a new report
    lastLoaded: [getLastLoadedCustomReports(state)],
});

export const reportsIndex = () => Api.reportsIndex(1, { typeIds: REPORT_TYPE_CUSTOM_IDS });
const ConnectedCustomReportsList = compose<Props, {}>(
    connect(mapStateToProps, null),
    connectToApi({
        actionCreators: [reportsIndex],
    }),
)(CustomReportsList);

export {
    CustomReportsList as CustomReportsListPresenter,
    ConnectedCustomReportsList as CustomReportsList,
    Props as CustomReportsListProps,
    CustomReportsListStateProps,
};
